/* Stylesheet */

.segment_toolbar {
  padding: 0px 12px 0px 21px;
  display: flex;
  height: 42px;
  align-items: center;
  justify-content: space-between;
  background: var(--ion-gradient-light);

  .label_container {
    display: flex;
    align-items: center;
    font-weight: 500;

    .label {
      text-transform: uppercase;
    }
  }

  .logical_label {
    padding: 0px 21px 0px 16px;
    height: 42px;
    min-width: 112px;
    border-radius: 0px 48px 48px 0px;

    .icon {
      margin: 0px 10px 0px 0px;
      height: 24px;
      width: 24px;
      color: #ffffff;
    }

    .label {
      color: #ffffff !important;
    }
  }

  .button_container {
    display: flex;
    gap: 12px;
  }
}
